/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom serializer that adds company settings fields
 * @export
 * @interface CompanySettings
 */
export interface CompanySettings {
    /**
     * 
     * @type {boolean}
     * @memberof CompanySettings
     */
    eventsEnableAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySettings
     */
    eventsExtraNotesField?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySettings
     */
    approvalFlowEnabled?: boolean;
}

/**
 * Check if a given object implements the CompanySettings interface.
 */
export function instanceOfCompanySettings(value: object): value is CompanySettings {
    return true;
}

export function CompanySettingsFromJSON(json: any): CompanySettings {
    return CompanySettingsFromJSONTyped(json, false);
}

export function CompanySettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySettings {
    if (json == null) {
        return json;
    }
    return {
        
        'eventsEnableAttachments': json['events_enable_attachments'] == null ? undefined : json['events_enable_attachments'],
        'eventsExtraNotesField': json['events_extra_notes_field'] == null ? undefined : json['events_extra_notes_field'],
        'approvalFlowEnabled': json['approval_flow_enabled'] == null ? undefined : json['approval_flow_enabled'],
    };
}

export function CompanySettingsToJSON(json: any): CompanySettings {
    return CompanySettingsToJSONTyped(json, false);
}

export function CompanySettingsToJSONTyped(value?: CompanySettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events_enable_attachments': value['eventsEnableAttachments'],
        'events_extra_notes_field': value['eventsExtraNotesField'],
        'approval_flow_enabled': value['approvalFlowEnabled'],
    };
}

